import script from "./ProjectContextHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectContextHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectContextHeader.vue?vue&type=style&index=0&id=5e7bf934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7bf934"]])

export default __exports__